import React from 'react'
import { Box, BoxProps } from '@material-ui/core'
import SocialIcon, { SocialIconProps } from 'components/shared/SocialIcon'

export interface SocialIconsProps extends BoxProps {
  items: SocialIconProps[]
  iconColor: string
}

const SocialIcons: React.FC<SocialIconsProps> = ({ items, iconColor, ...props }) => {
  return (
    <Box {...props}>
      {items.map((item) => (
        <SocialIcon key={item.url} {...item} iconColor={iconColor} />
      ))}
    </Box>
  )
}

export default SocialIcons
